import { gql } from '@apollo/client';

export const GET_AUDIT_ITEMS = gql`
  query GetAuditItems($input: AuditItemsInput!) {
    auditItems(input: $input) {
      items {
        id
        type
        createdBy
        createdAt
        lastModifiedBy
        lastModifiedAt
        auditSessionId
        status
        position
        decisionsCount
        selectedDecisionId
        contentSnapshot {
          audioFileUrl
          contentUrl
          transcription
          language
          topic
          contentType
          classificationType
          classificationResults {
            name
            severity
          }
          triggeredPolicies {
            id
            name
            description
            isEnabled
            labels {
              labelId
              severity
            }
          }
          nonTriggeredPolicies {
            id
            name
            description
            communityId
            isEnabled
            labels {
              labelId
              severity
            }
          }
          slmModelVersion
          slmPromptVersion
          quicktxtModelVersion
          metadata
        }
        kustoReference {
          communityId
          subjectId
          timestamp
        }
      }
      totalCount
      page
      pageSize
    }
  }
`;
